import { Navigate, useLocation } from 'react-router-dom'

import { paths } from './paths'

/**
 * Catch-all redirect for legacy `/profile/:userId/<segment>` URLs.
 *
 * The current user is resolved from the session — the `:userId` param is
 * discarded. Unknown segments fall back to the canonical Account landing.
 */
const legacyTargetMap: Record<string, string> = {
  personal: paths.account.profile,
  personal_information: paths.account.profile,
  authentication: paths.account.authentication,
  authentication_methods: paths.account.authentication,
  change_password: paths.account.authentication,
  'connected-accounts': paths.account.authentication,
  security: paths.account.security,
  notifications: paths.account.notifications,
  audit: paths.account.audit,
  sessions: paths.account.sessions
}

const segmentFrom = (pathname: string): string | undefined => {
  const match = pathname.match(/^\/profile\/[^/]+\/([^/?#]+)/)

  return match?.[1]
}

export const AccountLegacyRedirect = () => {
  const location = useLocation()
  const segment = segmentFrom(location.pathname)
  const target = (segment && legacyTargetMap[segment]) ?? paths.account.profile

  return <Navigate to={target} replace />
}
